import { Box, Typography } from '@mui/material';
import { GameEntity } from '@okletsplay/core';
import classNames from 'classnames';
import React, { FC, useCallback } from 'react';
import { useStyles } from './GameCard.styles';

interface GameCardProps {
  game: GameEntity;
  onChange: (game: GameEntity) => void;
  isActive?: boolean;
  cardColor?: string;
}

export const GameCard: FC<GameCardProps> = ({
  game,
  onChange,
  isActive,
  cardColor = '#1b1c1f',
}) => {
  const { classes } = useStyles({ cardColor });

  const onClickHandler = useCallback(() => {
    onChange(game);
  }, [game, onChange]);

  return (
    <Box onClick={onClickHandler} className={classNames(classes.root, { active: isActive })}>
      <Box className={classes.imageContainer}>
        <img src={game.selectionImage ?? game.activityImage} alt={game.title} />
      </Box>
      <Typography className={classes.title}>{game.title}</Typography>
    </Box>
  );
};
